<template>
    <div class="dropdown-container">
      <!-- Dropdown Button -->
      <button @click="toggleDropdown" class="dropdown-button">
        <span class="dropdown-title" style="text-wrap: no-wrap; font-weight: 700; font-size: 12px;">
          <span class="icon">👤</span> Sort By: {{ getSelectedOptionLabel }}
        </span>
        <span class="dropdown-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke-width="2"
            stroke="currentColor"
            class="menu-icon"
            :class="{ 'rotate-icon': isDropdownOpen }"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 9l6 6 6-6"
            />
          </svg>
        </span>
      </button>
  
      <!-- Dropdown Menu -->
      <div v-if="isDropdownOpen" class="dropdown-menu">
        <!-- Sort Options -->
        <div class="sort-options">
          <div 
            v-for="option in sortOptions" 
            :key="option.id" 
            class="sort-item"
            @click="selectSortOption(option.id)"
          >
            <span class="sort-label" style="text-wrap: no-wrap; font-weight: 600; font-size: 12px;">
              {{ option.label }}
            </span>
            <!-- Show checkbox only for selected option -->
            <input 
              v-if="selectedSortOption === option.id"
              type="checkbox" 
              class="checkbox-input" 
              checked
              :style="{ backgroundColor: selectedSortOption === option.id ? 'green' : 'transparent' }"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
export default {
  props: {
    handleSort: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedSortOption: 'az', // Default selected option
      sortOptions: [
        { id: 'az', label: 'A - Z' },
        { id: 'priority', label: 'Popularity' },
      ],
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    // Call handleSort from the parent component and pass the selected option
    selectSortOption(optionId) {
      const selectedOption = this.sortOptions.find(option => option.id === optionId);
      if (selectedOption) {
        this.selectedSortOption = optionId;
        this.isDropdownOpen = false; // Close dropdown after selection
        this.handleSort(selectedOption); // Call the parent's handleSort function
      }
    },
  },

  computed: {
    getSelectedOptionLabel() {
      const selectedOption = this.sortOptions.find(option => option.id === this.selectedSortOption);
      return selectedOption ? selectedOption.label : 'A to Z'; // Default label
    },
  },
};
</script>
  
  <style scoped>
  .dropdown-container {
    width: 170px;
    position: relative;
  }
  
  .dropdown-button {
    width: 100%;
    background-color: #2b2740;
    border-radius: 5px;
    padding: 10px;
    color: white;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border: none;
  }
  
  .dropdown-title {
    display: flex;
    align-items: center;
  }
  
  .icon {
    margin-right: 8px;
  }
  
  .dropdown-icon {
    font-size: 1rem;
    background-color: #3b3955;
    height: 23px;
    width: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  
  .menu-icon {
    width: 16px;
    height: 16px;
    transition: transform 0.3s ease;
  }
  
  .rotate-icon {
    transform: rotate(180deg);
  }
  
  .dropdown-menu {
    position: absolute;
    width: 100%;
    background-color: #2b2740;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 10;
    margin-top: -1px;
    max-height: 300px;
    overflow-y: auto;
    padding: 10px;
  }
  
  .sort-options {
    display: flex;
    flex-direction: column;
  }
  
  .sort-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    color: white;
    font-size: 14px;
    border-radius: 5px;
    transition: background-color 0.3s;
  }
  
  .sort-item:hover {
    background-color: #3b3955;
  }


 .checkbox-input {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  accent-color: #01BD71;
 }
  .checkbox:checked {
    background-color:#01BD71;
  }
  </style>
  